import React from "react";

export default () => (<svg viewBox="0 0 15.21 15.21" width="15" height="15">
  <title>Reset</title>
  <circle cx="7.61" cy="7.61" r="7.61"/>
  <path d="M4.44,6.17a3.5,3.5,0,1,1,3.21,4.89" fill="none" stroke="#edf9fe" />
  <polyline points="4.15 3.65 4.15 6.39 6.65 6.39" fill="none" stroke="#edf9fe" />
</svg>)